import actions from './actions';
import { createReducer } from '../../../helpers/reducer';

const initState = {
  data: [],
  filteredTotal: 0,
  filters: [],
  loading: false,
  sortableColumns: [],
  total: 0,
};

function onLoadRequest(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal, filters, sortableColumns } = payload;

  return {
    ...state,
    data,
    filteredTotal,
    filters,
    loading: false,
    sortableColumns,
    total,
  };
}

function onLoadFailure(state) {
  return {
    ...state,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadRequest,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.LOAD_FAILURE]: onLoadFailure,
  [actions.CLEAR_STORE]: onClearStore,
});
